import { render, staticRenderFns } from "./CadastroLayoutEtiqueta.vue?vue&type=template&id=d0281886&"
import script from "./CadastroLayoutEtiqueta.vue?vue&type=script&lang=js&"
export * from "./CadastroLayoutEtiqueta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports